/**
 * Name of the document type used for patient identity documents (driver's
 * license, photo ID, passport, etc.). Tenants opt into the "ID at the top of
 * the chart" feature simply by having a document type with this name; matching
 * is case-insensitive.
 */
export const ID_DOCUMENT_TYPE_NAME = "ID";

export interface DocumentSummary {
  id: string;
  patientId: string;
  filePath: string;
  fileType: string;
  title: string;
  summary: string | null;
  docType: string;
  signatureUrl: string | null;
  expiryDate?: string | null;
  createdDate?: string;
  updatedDate?: string;
  noteIds: string[];
  sourceNoteId: string | null;
  reviewedByProviderId: string | null;
  reviewedDate: string | null;
  reviewComment: string | null;
  sharedWithPatient: boolean;
  sharedDate: string | null;
  sharedByProviderId: string | null;
  patientMessage: string | null;
  // Set when the document was uploaded inside a patient form submission. Used to
  // open the originating form from the Documents tab.
  sourceAnsweredFormId?: string | null;
  sourceFormId?: string | null;
  sourceFormName?: string | null;
}

export interface DocumentTableItem extends DocumentSummary {
  createdDate: string;
}

export interface DocumentTypeConfig {
  id: string;
  name: string;
  isArchived: boolean;
}
